<template lang="pug">
#modal-editar-dados-contato-pssc
    el-dialog(
        :title="$t('mensagens.pssc.telaLista.modalEditarDadosContato.titulo')",
        :width='width',
        :visible.sync='show_',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        show-close,
        @close='closeDialog()'
    )
        .modal-editar-dados-contato__content
            section.numero-car
                div {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.codigoCar') }}
                el-input.el-input_edicao-car(
                    v-model='codigoCar',
                    @input='',
                    :disabled='true'
                )

            section.dados-contato
                div.modal-texto-bold {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.proprietarios') }}
                section.dados-contato__container
                    div(
                        v-for='(contato, index) in dadosContato',
                        :key='index',
                    )
                        .dados-contato-proprietario
                            .dados-contato__column
                                div.modal-texto-bold {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.documento') }}
                                el-input(
                                    v-model='contato.documentoFormatado',
                                    @input='',
                                    :disabled='true'
                                )

                            .dados-contato__column
                                div.modal-texto-bold {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.email') + ' ' }}
                                    sup.campo-obrigatorio *
                                el-input(
                                    v-model='contato.email',
                                    @input='validarDadosContato()'
                                )
                                div.campo-invalido
                                    sup(
                                        v-if='!emailValido(contato.email) && contato.email!==""'
                                    ) {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.emailInvalido') }}
                            .dados-contato__column
                                div.modal-texto-bold {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.telefone') + ' ' }}
                                    sup.campo-obrigatorio *
                                el-input(
                                    placeholder='Ex: (00)00000-0000',
                                    v-model='contato.telefone',
                                    v-mask='["(##) ####-####", "(##) #####-####"]',
                                    @input='validarDadosContato()'
                                )
                                div.campo-invalido
                                    sup(
                                        v-if='!telefoneValido(contato.telefone)'
                                    ) {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.telefoneInvalido') }}
                            .dados-contato__column
                                div.modal-texto-bold {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.telefoneAdicional') }}
                                el-input(
                                    placeholder='Ex: (00)00000-0000',
                                    v-model='contato.telefoneAdicional',
                                    v-mask='["(##) ####-####", "(##) #####-####"]',
                                    @input='validarDadosContato()'
                                )
                                div.campo-invalido
                                    sup(
                                        v-if='!telefoneAdicionalValido(contato.telefoneAdicional)'
                                    ) {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.telefoneInvalido') }}

        .dialog-footer(slot='footer')
            el-button.outline-button(
                type='outline',
                size='mini',
                @click='closeDialog'
            ) {{ $t('mensagens.comuns.cancelar') }}
            el-button.primary-button(
                type='primary',
                size='mini',
                @click='salvarAlteracoes',
                :disabled='desabilitarBotaoSalvar'
            ) {{ $t('mensagens.pssc.telaLista.modalEditarDadosContato.botaoSalvarAlteracoes') }}
</template>

<script>
import PSSCService from '@/services/PSSCService';
import validators from '@/utils/validators';

export default {
    name: 'ModalEditarDadosContato',
    emits: ['showNotificacaoSucesso'],
    components: { },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        territorio: {
            default: null,
            required: true
        }
    },

    data() {
        return {
            loading: {
            },

            show_: false,
            width: '71%',
            desabilitarBotaoSalvar: true,

            dadosContato: [],
            codigoCar: '',
            dadosPais: {
                sigla: 'br',
                codigo: '+55'
            }
        };
    },

    watch: {
        show: {
            handler() {
                this.show_ = this.show;
                if (this.show) {
                    this.buscarContatos();
                }
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            this.show_ = false;
            this.$emit('closeDialog');
        },
        async buscarContatos() {
            try {
                if (this.show_ && (!this.territorio || this.territorio < 0)) {
                    throw new Error();
                } else {
                    await PSSCService.buscarDadosContatoTerritorio(this.territorio)
                    .then(({data}) => {
                        this.codigoCar = data.codigoCar;
                        this.dadosContato = data.contatos;
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.pssc.telaLista.modalEditarDadosContato.erroBuscarContatos')
                        });
                    })
                    .finally(() => {
                        this.validarDadosContato();
                    });
                }
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaLista.modalEditarDadosContato.erroBuscarContatos')
                });
                this.closeDialog();
            }
        },
        emailValido(email) {
            return validators.validarEmail(email);
        },
        telefoneValido(telefone) {
            return (telefone && (telefone.length === 14 || telefone.length === 15));
        },
        telefoneAdicionalValido(telefone) {
            return (!telefone || telefone?.length === 14 || telefone?.length === 15 || telefone === '');
        },
        validarDadosContato() {
            var contatos = this.dadosContato;
            var retorno = false;
            for (var i = 0; i < this.dadosContato.length; i++) {
                if (
                    !this.emailValido(contatos[i].email) ||
                    !this.telefoneValido(contatos[i].telefone) ||
                    !this.telefoneAdicionalValido(contatos[i].telefoneAdicional)
                ) {
                    retorno = true;
                }
            }
            
            this.desabilitarBotaoSalvar = retorno;
        },
        async salvarAlteracoes() {
            var contatos = [];
            this.dadosContato.forEach(dadoContato => {
                let contatoAtualizado = {
                    'idRepresentante': dadoContato.idRepresentante,
                    'email': dadoContato.email,
                    'telefone': this.formatarTelefone(dadoContato.telefone),
                    'telefoneAdicional': this.formatarTelefone(dadoContato.telefoneAdicional)
                };
                contatos.push(contatoAtualizado);
            });

            await PSSCService.atualizarContatos(contatos)
            .then(() => {
                this.$notify.success({
                    message: this.$t('mensagens.pssc.telaLista.modalEditarDadosContato.sucessoAtualizarContatos')
                });
            })
            .catch(() => {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaLista.modalEditarDadosContato.erroAtualizarContatos')
                });
            });
            this.dadosContato = [];
            this.closeDialog();
        },
        formatarTelefone(telefone) {
            return (!telefone || telefone === '') ? null : (
                this.dadosPais.sigla + ' ' +
                this.dadosPais.codigo + ' ' +
                telefone
            );
        }
    }
};
</script>

<style lang="scss">
#modal-editar-dados-contato-pssc {
    .modal-editar-dados-contato__content {
        max-height: 425px;
        .numero-car {
            margin-top: 16px;
        }

        .dados-contato {
            padding: 16px 0;
            max-height: fit-content;
            .dados-contato__container {
                min-height: 100px;
                border: 1px solid #cccccc;
                border-radius: 4px;
                padding: 16px 0 0 0;
                margin-top: 5px;

                .dados-contato-proprietario{
                    display: flex;
                    justify-items: center;
                    padding: 0 16px;
                    gap: 8px;

                    .dados-contato__column {
                        width: 25%;
                        min-height: 75px;
                    }
                }
            }
        }

        .el-input_edicao-car {
            padding: 5px 0;
        }
    }

    .campo-invalido {
        color: #DC362E;
        margin: 5px 0 0 0;
        height: 15px;
    }
    .campo-obrigatorio {
        color: #FF0000;
    }
    .modal-texto-bold {
        font-weight: 500;
    }

    .el-dialog__footer {
        margin-top: 0;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;

        .dialog-footer {
            display: flex;
            justify-content: flex-end;
            gap: 16px;
        }
    }

    .el-dialog__close {
        color: #3B3B3B;
        &:before {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .outline-button {
        margin: 0px !important;
    }

    .primary-button {
        margin: 0px !important;
    }

    .modal-text {
        font-family: 'Roboto', 'sans serif';
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        padding-bottom: 8px;
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #ffffff;
        padding-bottom: 0;
        span {
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        padding: 15px 20px !important;
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .el-dialog__body {
        max-height: 525px;
        padding: 15px;
    }

    .font-bold {
        font-weight: 600;
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }
}
</style>
